module.exports = __webpack_public_path__ + "50623e6a761b392b5381ce35e8a77f99.svg";